import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const buyers = [['Mariana', 'Córdoba'], ['Rocío', 'Buenos Aires'], ['Carla', 'Mendoza'], ['Verónica', 'Rosario'], ['Sofía', 'Salta'], ['Laura', 'La Plata']];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [buyer, setBuyer] = useState(buyers[0]);
  useEffect(() => {
    const show = () => {
      setBuyer(buyers[Math.floor(Math.random() * buyers.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 4500);
    };
    const initial = window.setTimeout(show, 15000);
    const cycle = window.setInterval(show, 42000);
    return () => {
      window.clearTimeout(initial);
      window.clearInterval(cycle);
    };
  }, []);
  return <AnimatePresence data-id="element-301" data-mp="3f42xwgqxoyy4">{visible && <motion.aside initial={{
      opacity: 0,
      x: -28
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -28
    }} transition={{
      duration: .32
    }} className="fixed bottom-5 left-4 z-[60] max-w-[290px] rounded-2xl border border-line bg-bg-card p-4 shadow-xl" aria-live="polite" data-id="element-302" data-mp="3f2ruwj5bbv82"><div className="flex gap-3" data-id="element-303" data-mp="8bydk8nmrju3"><div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brandOrange/10 text-brandOrange" data-id="element-304" data-mp="8cq8ridbffju"><ShoppingBagIcon size={18} data-id="element-305" data-mp="mcis2smiiths" /></div><div data-id="element-306" data-mp="m9my1fdscoym"><p className="text-sm font-bold text-txt-primary" data-id="element-307" data-mp="m9d5bk1cw3p8">{buyer[0]} de {buyer[1]}</p><p className="mt-0.5 text-xs leading-5 text-txt-body" data-id="element-308" data-mp="hbbkouoa7wbn">se sumó a <strong className="text-brandOrange" data-id="element-309" data-mp="vbmcq11bvgye">Método Porción Rentable®</strong></p><p className="mt-1 text-[11px] text-txt-muted" data-id="element-310" data-mp="rb2h51wekled">hace unos minutos</p></div><button type="button" onClick={() => setVisible(false)} className="ml-auto text-xs text-txt-muted" aria-label="Cerrar aviso" data-id="element-311" data-mp="r8q0cs2dsh2w">×</button></div></motion.aside>}</AnimatePresence>;
}